import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Link, NavLink, Route, Routes } from 'react-router-dom';
import './App.css';
import store from './app/store';
import RouteChecklistCreate from './features/checklists/RouteChecklistCreate';
import RouteChecklistDetail from './features/checklists/RouteChecklistDetail';
import RouteChecklistEdit from './features/checklists/RouteChecklistEdit';
import RouteChecklists from './features/checklists/RouteChecklists';
import RouteDebug from './features/debug/RouteDebug';
import RouteGoalClone from './features/goals/RouteGoalClone';
import RouteGoalCreate from './features/goals/RouteGoalCreate';
import RouteGoalDetail from './features/goals/RouteGoalDetail';
import RouteGoalEdit from './features/goals/RouteGoalEdit';
import RouteGoals from './features/goals/RouteGoals';
import RouteEntries from './features/measurements/RouteEntries';
import RouteMeasurementCreate from './features/measurements/RouteMeasurementCreate';
import RouteMeasurementDetail from './features/measurements/RouteMeasurementDetail';
import RouteMeasurementEdit from './features/measurements/RouteMeasurementEdit';
import RouteMeasurements from './features/measurements/RouteMeasurements';
import ProvideAuth from './features/signin/ProvideAuth';
import RequireAuth from './features/signin/RequireAuth';
import RouteSignIn from './features/signin/RouteSignIn';
import SignInButton from './features/signin/SignInButton';

function App() {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <Provider store={store}>
      <ProvideAuth>
        <Router>
          <Navbar bg="primary" variant="dark" fixed="top" expand="lg" expanded={expanded} onToggle={setExpanded} collapseOnSelect={true}>
            <Container fluid>
              <Navbar.Brand as={Link} href="/" to="/" onClick={() => setExpanded(false)}>wam.town</Navbar.Brand>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Item>
                    <Nav.Link as={NavLink} href="/goals" to="/goals">Goals</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} href="/checklists" to="/checklists">Checklists</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} href="/measurements" to="/measurements">Measurements</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Nav>
                  <Nav.Item>
                    <SignInButton onClick={() => setExpanded(false)} />
                  </Nav.Item>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
          <Container className="rootContainer">
            <Routes>
              <Route path="/login" element={<RouteSignIn />} />
              <Route path="/checklists" element={
                <RequireAuth>
                  <RouteChecklists />
                </RequireAuth>
              } />
              <Route path="/checklist/create" element={
                <RequireAuth>
                  <RouteChecklistCreate />
                </RequireAuth>
              } />
              <Route path="/checklist/:checklistID/edit" element={
                <RequireAuth>
                  <RouteChecklistEdit />
                </RequireAuth>
              } />
              <Route path="/checklist/:checklistID" element={
                <RequireAuth>
                  <RouteChecklistDetail />
                </RequireAuth>
              } />
              <Route path="/goal/create" element={
                <RequireAuth>
                  <RouteGoalCreate />
                </RequireAuth>
              } />
              <Route path="/goal/:goalID/edit" element={
                <RequireAuth>
                  <RouteGoalEdit />
                </RequireAuth>
              } />
              <Route path="/goal/:goalID/clone" element={
                <RequireAuth>
                  <RouteGoalClone />
                </RequireAuth>
              } />
              <Route path="/goal/:goalID" element={
                <RequireAuth>
                  <RouteGoalDetail />
                </RequireAuth>
              } />
              <Route path="/goals" element={
                <RequireAuth>
                  <RouteGoals />
                </RequireAuth>
              } />
              <Route path="/measurement/create" element={
                <RequireAuth>
                  <RouteMeasurementCreate />
                </RequireAuth>
              } />
              <Route path="/measurement/:measurementID/edit" element={
                <RequireAuth>
                  <RouteMeasurementEdit />
                </RequireAuth>
              } />
              <Route path="/measurement/:measurementID" element={
                <RequireAuth>
                  <RouteMeasurementDetail />
                </RequireAuth>
              } />
              <Route path="/measurements" element={
                <RequireAuth>
                  <RouteMeasurements />
                </RequireAuth>
              } />
              <Route path="/debug" element={
                <RequireAuth>
                  <RouteDebug />
                </RequireAuth>
              } />
              <Route path="/" element={
                <RequireAuth>
                  <RouteEntries />
                </RequireAuth>
              } />
            </Routes>
          </Container>
        </Router>
      </ProvideAuth>
    </Provider>
  );
}
export default App;
